// Which arcade spots (cabinets, wall TV) are clickable on a hub beat, derived
// from the saved course progress. Shared by the 3D arrows (ArcadeMarkers) and
// the DOM click labels (HubPins) so both always agree.
//
// Guided tour: only the next station shows an arrow. Free walk: the TV is
// always available; the cabinets appear after the briefing.

import type { ArcadeSpotSpec } from "../../scenario/types";
import { allDone, nextTarget, type ArcadeGameId, type ArcadeProgress } from "./results";

export type SpotState = "active" | "done" | "hidden";

const GAME_OF: Record<string, ArcadeGameId> = {
  turkey: "turkeyhunt",
  fraud: "spotfraud",
  invaders: "invaders",
  turkeyhunt: "turkeyhunt",
  spotfraud: "spotfraud",
};

export function spotState(spot: ArcadeSpotSpec, p: ArcadeProgress, hubActive: boolean): SpotState {
  if (!hubActive) return "hidden";
  if (p.mode === "guided") return spot.id === nextTarget(p) ? "active" : "hidden";
  if (spot.role === "tv") return "active";
  if (!p.briefed) return "hidden";
  const g = spot.gameId ? GAME_OF[spot.gameId] : undefined;
  return g && p.results[g] ? "done" : "active";
}

export function spotStates(spots: ArcadeSpotSpec[], p: ArcadeProgress, hubActive: boolean): Record<string, SpotState> {
  const out: Record<string, SpotState> = {};
  for (const s of spots) out[s.id] = spotState(s, p, hubActive);
  return out;
}

export function spotLabel(spot: ArcadeSpotSpec, state: SpotState, p: ArcadeProgress): string {
  if (spot.role === "tv") {
    if (!p.briefed) return spot.label;
    return allDone(p) ? spot.finalLabel ?? "See your final score" : spot.doneLabel ?? "Watch the briefing again";
  }
  if (state === "done") return spot.doneLabel ?? `Replay ${spot.label.replace(/^Play\s+/i, "")}`;
  return spot.label;
}
